import CrudCustom from '../../../libs/custom/CrudCustom';

let PerusahaanSettingService = new CrudCustom('/perusahaan-settings');
export default PerusahaanSettingService;
